import lightbox from 'fslightbox';
(function(e){"use strict";e.fn.counterUp=function(t){var n=e.extend({time:2000,delay:10},t);return this.each(function(){var t=e(this),r=n,i=function(){var e=[],n=r.time/r.delay,i=t.text(),s=/[0-9]+,[0-9]+/.test(i);i=i.replace(/,/g,"");var o=/^[0-9]+$/.test(i),u=/^[0-9]+\.[0-9]+$/.test(i),a=u?(i.split(".")[1]||[]).length:0;for(var f=n;f>=1;f--){var l=parseInt(i/n*f);u&&(l=parseFloat(i/n*f).toFixed(a));if(s)while(/(\d+)(\d{3})/.test(l.toString()))l=l.toString().replace(/(\d+)(\d{3})/,"$1,$2");e.unshift(l)}t.data("counterup-nums",e);t.text("0");var c=function(){t.text(t.data("counterup-nums").shift());if(t.data("counterup-nums").length)setTimeout(t.data("counterup-func"),r.delay);else{delete t.data("counterup-nums");t.data("counterup-nums",null);t.data("counterup-func",null)}};t.data("counterup-func",c);setTimeout(t.data("counterup-func"),r.delay)};t.waypoint(i,{offset:"100%",triggerOnce:!0})})}})(jQuery);
jQuery(function(){	
	
	const themeLocation = jQuery('.header').data('theme-location');
	
	jQuery('a[href*="#"]')
	  // Remove links that don't actually link to anything
	  .not('[href="#"]')
	  .not('[href="#0"]')
	  .click(function(event) {
		// On-page links
		if ( 
		  location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')  
		  && 
		  location.hostname == this.hostname
		) {
		  // Figure out element to scroll to
		  var target = jQuery(this.hash); 
		  target = target.length ? target : jQuery('[name=' + this.hash.slice(1) + ']');
		  // Does a scroll target exist?
		  if (target.length) {
			// Only prevent default if animation is actually gonna happen
			event.preventDefault();
			jQuery('html, body').animate({
			  scrollTop: target.offset().top - 80
			}, 1000, function() {
			  // Callback after animation
			  // Must change focus!

			});
		  } 
		}
	  }); 

	jQuery(".show-next").on('click', function(e){ 
		e.preventDefault();
		jQuery(this).hide();
		jQuery(this).parent().next().show();
	});
	jQuery('.count-number').counterUp( {
		delay: 16,
	}); 
	/**Mobile menu **/ 
	jQuery('.arrow-down').on('click', function() {
		jQuery('html, body').animate({
		  scrollTop: jQuery(".scrollable-col").offset().top - 80
		}, 1000, function() {
		  // Callback after animation
		  // Must change focus!
 
		});
	});

	jQuery('.hamburger').on('click', function() {
		jQuery(this).toggleClass('open-h'); 
		jQuery('.mobile-overlay').toggleClass('small-h');
	});	
	
	jQuery('.search-mob').on('click', function() {
		jQuery('.hamburger').toggleClass('open-h'); 
		jQuery('.mobile-overlay').toggleClass('small-h');
		jQuery('.mobile-overlay .search-field').focus();
	}); 

	jQuery('.show-desc').on('click', function() {
		jQuery(this).toggleClass('open',500); 
		jQuery(this).parent().next().next().toggleClass('open');
	}); 

	jQuery('.scrollToTop').on('click', function(event) {
		event.preventDefault();
		jQuery('html, body').animate({
		  scrollTop:0
		}, 1000, function() {
		  // Callback after animation
		  // Must change focus!

		});
	}); 
    // Function to get wishlist from local storage
    function getWishlist() {
        return JSON.parse(localStorage.getItem('wishlist')) || [];
    }

    // Function to save wishlist to local storage
    function saveWishlist(wishlist) {
        localStorage.setItem('wishlist', JSON.stringify(wishlist));
    } 

    // Update the wishlist count based on local storage
    function updateWishlistCount(count) {
        jQuery('.wishlist-count').text(count);
    }
	function initWishlistCount() {
        var count = isLoggedIn ? jQuery('.wishlist-toggle').data('count') : getWishlist().length;
        updateWishlistCount(count);
    }
    function removeFromWishlist(postId) {
        let wishlist = getWishlist();
        wishlist = wishlist.filter(item => item !== postId);
        saveWishlist(wishlist);
        alert('Produkt został usunięty z listy');
		setTimeout(function(){
			location.reload();
		}, 500);
         // Reload the page to update the wishlist display
    } 
		if(!isLoggedIn){
			const wishlistItems = getWishlist();
			if(document.getElementById('non-logged-wishlist')){
				const wishlistContainer = document.getElementById('non-logged-wishlist');
	
				if (wishlistItems.length === 0) {
					wishlistContainer.innerHTML = '<div class="wishlist-empty"><img src="' + themeLocation + '/assets/img/ulubione.svg" alt="Ulubione" width="17" height="18"  /><h3>Dodaj tutaj coś :)</h3> Lista jest pusta</div>';
				} else {
					wishlistContainer.innerHTML = ''; // Clear the empty message
					console.log(wishlistItems);
					wishlistItems.forEach(item => {
						const listItem = document.createElement('div');
						listItem.innerHTML = `<a href="${item.permalink}"><img src='${item.img}' alt='${item.name}' ?>${item.name}</a><a class="expand rem tooltip" href="${item.permalink}"><span class="tooltiptext ">Więcej informacji</span><img src="${themeLocation}/assets/img/arrow-right.png" alt="Podgląd"></a> 
											  <a class="wishlist-toggle btn reload" data-post-id="${item.id}" data-action="remove">Usuń z listy</a>`;
						wishlistContainer.appendChild(listItem);
					});
				}
			}
		}
    function setWishlistButtonStates() {
        if (isLoggedIn) {
    
        } else {
            // For non-logged-in users, check local storage
            var localWishlist = getWishlist();
			console.log(localWishlist);
            jQuery('.wishlist-toggle').each(function() {
                var postId = jQuery(this).data('post-id');
                if (localWishlist.some(item => item.id == postId)) {
                    jQuery(this).html('<img src="' + themeLocation + '/assets/img/ulubione-added.svg" alt="Ulubione" width="17" height="18"  /><span class="tooltiptext">Usuń z ulubionych</span>').data('action', 'remove');
                } else {
                    jQuery(this).html('<img src="' + themeLocation + '/assets/img/ulubione.svg" alt="Ulubione" width="17" height="18"  /><span class="tooltiptext">Dodaj do ulubionych</span>').data('action', 'add');
                }
            });
        }
    }

    // Initial count update
    initWishlistCount();
	setWishlistButtonStates();
	jQuery(".reload").on('click', function(){
		setTimeout(function(){
			location.reload();
		}, 500);
	});
    jQuery('.wishlist-toggle').on('click', function() {
        var postId = jQuery(this).data('post-id');
        var action = jQuery(this).data('action');
        var ajaxUrl = jQuery(this).data('ajax-url');

        if (isLoggedIn) {
            // Handle for logged-in users
            jQuery.ajax({
                url: ajaxUrl,
                type: 'POST',
                data: {
                    action: 'handle_wishlist',
                    post_id: postId,
                    wishlist_action: action,
                },
                success: function(response) {
                    if (response.success) {
						if (action == 'add') {
							jQuery('a[data-post-id="' + postId + '"]').html('<img src="' + themeLocation + '/assets/img/ulubione-added.svg" alt="Ulubione" width="17" height="18"  /><span class="tooltiptext">Usuń z ulubionych</span>').data('action', 'remove');
						} else {
							jQuery('a[data-post-id="' + postId + '"]').html('<img src="' + themeLocation + '/assets/img/ulubione.svg" alt="Ulubione" width="17" height="18"  /><span class="tooltiptext">Dodaj do ulubionych</span>').data('action', 'add');
						}
                    }
					updateWishlistCount(response.data.count); // Update count after action
                }
            });
        } else {
            // Handle for non-logged-in users
            var wishlist = getWishlist();
            if (action === 'add') {
				var productName = jQuery(this).data('title');
				var productPermalink = jQuery(this).data('permalink');
				var img = jQuery(this).data('img');
				if (!wishlist.some(item => item.id === postId)) {
					wishlist.push({ id: postId, name: productName, permalink: productPermalink, img: img }); // Store as an object
				}
                jQuery('a[data-post-id="' + postId + '"]').html('<img src="' + themeLocation + '/assets/img/ulubione-added.svg" alt="Ulubione" width="17" height="18"  /><span class="tooltiptext">Usuń z ulubionych</span>').data('action', 'remove');
            } else {
				wishlist = wishlist.filter(item => item.id !== postId); 
				jQuery('a[data-post-id="' + postId + '"]').html('<img src="' + themeLocation + '/assets/img/ulubione.svg" alt="Ulubione" width="17" height="18"  /><span class="tooltiptext">Dodaj do ulubionych</span>').data('action', 'add');
            }
            saveWishlist(wishlist); // Save updated wishlist
            updateWishlistCount(wishlist.length); // Update count after action
        }
    });
	

	jQuery('.home_courses_section .tutor-course-list').on('init', function() {
      //  jQuery('#preloader').fadeOut(500); // Ukrywa preloader po inicjalizacji
        jQuery('.home_courses_section .tutor-course-list').fadeIn(500);     // Pokazuje slider
    }).slick({
	  infinite: true,
	  centerMode: false,
	  slidesToShow: 4,
	  slidesToScroll: 4,
	  arrows: true,
	  dots: false,
	  lazyLoad: 'ondemand',
	  variableWidth: false,
	  prevArrow: '<a class="arrow-prev"><i class="arrow_carrot-left"></i></a>',
	  nextArrow: '<a class="arrow-next"><i class="arrow_carrot-right"></i></a>',
	  	autoplay: false,
	autoplaySpeed: 3000,
	adaptiveHeight: false,
	   responsive: [
		{ 
			breakpoint: 4000,
			settings: {
			  slidesToShow: 5,
			  slidesToScroll: 5,
			  variableWidth: false,
			}
		  },
		{ 
		breakpoint: 3000,
		settings: {
			slidesToShow: 4,
			slidesToScroll: 4,
			variableWidth: false,
		}
		},
		{ 
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2,
			variableWidth: false,
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			variableWidth: false,
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		},
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	  ]
	});

	jQuery('.our_customers .to-slick').slick({
	  infinite: true,
	  centerMode: false,
	  slidesToShow: 5,
	  slidesToScroll: 5,
	  arrows: true,
	  lazyLoad: 'ondemand',
	  dots: true,
	  prevArrow: '<a class="arrow-prev"><i class="arrow_carrot-left"></i></a>',
	  nextArrow: '<a class="arrow-next"><i class="arrow_carrot-right"></i></a>',
	  	autoplay: false,
	autoplaySpeed: 3000,
	   responsive: [
		{ 
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2,
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		},
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	  ]
	});

	jQuery('.prelegenci .wrapper-slick').slick({
	  infinite: true,
	  centerMode: false,
	  slidesToShow: 5,
	  slidesToScroll: 5,
	  arrows: true,
	  lazyLoad: 'ondemand',
	  dots: true,
	  prevArrow: '<a class="arrow-prev"><i class="arrow_carrot-left"></i></a>',
	  nextArrow: '<a class="arrow-next"><i class="arrow_carrot-right"></i></a>',
	  	autoplay: false,
	autoplaySpeed: 3000,
	   responsive: [
		{ 
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2,
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		},
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	  ]
	});
	jQuery('.side-hamburger').on('click', function() {
		jQuery(this).toggleClass('open-h'); 
		jQuery('.filter-sidebar').toggleClass('small-h');
			jQuery('.awards-wrapper .awards_row .filter-col').toggleClass('small-h');
	});
	jQuery('.home_courses_section2 .tutor-course-list').slick({
	  infinite: true,
	  centerMode: false,
	  slidesToShow: 4,
	  slidesToScroll: 4,
	  arrows: true,
	  lazyLoad: 'ondemand',
	  dots: false,
	  variableWidth: false,
	  adaptiveHeight: true,
	  prevArrow: '<a class="arrow-prev"><i class="arrow_carrot-left"></i></a>',
	  nextArrow: '<a class="arrow-next"><i class="arrow_carrot-right"></i></a>',
	  	autoplay: true,
	autoplaySpeed: 3000,
	   responsive: [
		{ 
			breakpoint: 4000,
			settings: {
			  slidesToShow: 5,
			  slidesToScroll: 5,
			  variableWidth: false,
			}
		  },
		{ 
		breakpoint: 3000,
		settings: {
			slidesToShow: 4,
			slidesToScroll: 4,
			variableWidth: false,
		}
		},
		{ 
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2,
			variableWidth: false,
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			variableWidth: false,
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		},
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	  ]
	});

	jQuery('.home_courses_section3 .tutor-course-list').slick({
	  infinite: true,
	  centerMode: false,
	  slidesToShow: 4,
	  slidesToScroll: 4,
	  arrows: true,
	  dots: false,
	  lazyLoad: 'ondemand',
	  variableWidth: false,
	  adaptiveHeight: true,
	  prevArrow: '<a class="arrow-prev"><i class="arrow_carrot-left"></i></a>',
	  nextArrow: '<a class="arrow-next"><i class="arrow_carrot-right"></i></a>',
	  	autoplay: true,
	autoplaySpeed: 3000,
	   responsive: [
		{ 
			breakpoint: 4000,
			settings: {
			  slidesToShow: 5,
			  slidesToScroll: 5,
			  variableWidth: false,
			}
		  },
		{ 
		breakpoint: 3000,
		settings: {
			slidesToShow: 4,
			slidesToScroll: 4,
			variableWidth: false,
		}
		},
		{ 
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2,
			variableWidth: false,
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			variableWidth: false,
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		},
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	  ]
	});
	
	jQuery('.home_opinions_section .desc-col .row').slick({
	  infinite: true,
	  centerMode: false,
	  slidesToShow: 4,
	  slidesToScroll: 4,
	  arrows: true,
	  dots: false,
	  prevArrow: '<a class="arrow-prev"><i class="arrow_carrot-left"></i></a>',
	  nextArrow: '<a class="arrow-next"><i class="arrow_carrot-right"></i></a>',
	  	autoplay: true,
	autoplaySpeed: 3000,
	   responsive: [
		{ 
		  breakpoint: 1260,
		  settings: {
			slidesToShow: 3,
			slidesToScroll: 3,
		  }
		},	
		{ 
		  breakpoint: 1024,
		  settings: {
			slidesToShow: 2,
			slidesToScroll: 2,
		  }
		},
		{
		  breakpoint: 600,
		  settings: {
			slidesToShow: 1,
			slidesToScroll: 1
		  }
		},
		// You can unslick at a given breakpoint now by adding:
		// settings: "unslick"
		// instead of a settings object
	  ]
	});
	
    jQuery('.open-cart-sidebar').on('click', function(e) {
		e.preventDefault();
        jQuery('#cart-sidebar').addClass('active');
    });

    // Close the cart sidebar
    jQuery('.close-cart-sidebar').on('click', function(e) {
		e.preventDefault();
        jQuery('#cart-sidebar').removeClass('active');
    });

    // Close sidebar on clicking outside
    jQuery(document).on('click', function(e) {
        if (!jQuery(e.target).closest('#cart-sidebar, .open-cart-sidebar').length) {
            jQuery('#cart-sidebar').removeClass('active');
        }
    });

	
    jQuery('.add_to_cart_button').on('click', function(e) {
		e.preventDefault();
       
		var product_id = jQuery(this).data('product_id');
        var quantity = jQuery(this).data('quantity') || 1;
        var ajax_url = '/wp-admin/admin-ajax.php';  // Directly using the AJAX URL

        // AJAX Request
		jQuery.ajax({
			url: ajax_url,
			type: 'POST',
			data: {
				action: 'check_cart_empty'
			},
			success: function(response) {
				if (!response.is_empty) {
					// Jeśli koszyk nie jest pusty, wyświetl alert
					alert('Można dodać tylko jedną subskrypcję do koszyka. Po opłaceniu otrzymasz dostęp do wszystkich.');
				} else {
					// Jeśli koszyk jest pusty, kontynuuj dodawanie produktu
					console.log(response.is_empty);
					jQuery.ajax({
						url: ajax_url,
						type: 'POST',
						data: {
							action: 'custom_add_to_cart',
							product_id: product_id,
							quantity: quantity
						},
						success: function(response) {
							if (response.error) {
								alert(response.message);
							} else {
								// Aktualizacja mini koszyka i liczby przedmiotów
								jQuery('#cart-sidebar .cart-contents').html(response.mini_cart);
								jQuery('.cart-items-count').text(response.cart_count);
	
								// Pokaż koszyk, jeśli jest ukryty
								jQuery('#cart-sidebar').addClass('active');
							}
						},
						error: function(xhr, status, error) {
							console.error('AJAX Error:', status, error);
							alert('Wystąpił błąd podczas dodawania produktu do koszyka. Spróbuj ponownie.');
						}
					});
				}
			},
			error: function(xhr, status, error) {
				console.error('AJAX Error:', status, error);
				alert('Wystąpił błąd podczas sprawdzania koszyka. Spróbuj ponownie.');
			}
		});
    });   
	
	jQuery('button.tutor-add-to-cart-button').on('click', function(e) {
		e.preventDefault();
       
		var product_id = jQuery(this).attr('value');
        var quantity = jQuery(this).data('quantity') || 1;
        var ajax_url = '/wp-admin/admin-ajax.php';  // Directly using the AJAX URL

        // AJAX Request
		jQuery.ajax({
			url: ajax_url,
			type: 'POST',
			data: {
				action: 'check_cart_empty'
			},
			success: function(response) {
				if (!response.is_empty) {
					// Jeśli koszyk nie jest pusty, wyświetl alert
					alert('Można dodać tylko jedną subskrypcję do koszyka. Po opłaceniu otrzymasz dostęp do wszystkich.');
				} else {
					console.log(response.is_empty);
					// Jeśli koszyk jest pusty, kontynuuj dodawanie produktu
					jQuery.ajax({
						url: ajax_url,
						type: 'POST',
						data: {
							action: 'custom_add_to_cart',
							product_id: product_id,
							quantity: quantity
						},
						success: function(response) {
							if (response.error) {
								alert(response.message);
							} else {
								// Aktualizacja mini koszyka i liczby przedmiotów
								jQuery('#cart-sidebar .cart-contents').html(response.mini_cart);
								jQuery('.cart-items-count').text(response.cart_count);
	
								// Pokaż koszyk, jeśli jest ukryty
								jQuery('#cart-sidebar').addClass('active');
							}
						},
						error: function(xhr, status, error) {
							console.error('AJAX Error:', status, error);
							alert('Wystąpił błąd podczas dodawania produktu do koszyka. Spróbuj ponownie.');
						}
					});
				}
			},
			error: function(xhr, status, error) {
				console.error('AJAX Error:', status, error);
				alert('Wystąpił błąd podczas sprawdzania koszyka. Spróbuj ponownie.');
			}
		});
    });

	jQuery(document).on({
		mouseleave: function() {
		   jQuery(this).find(".preview-wrapper").removeClass('on');
		}
	}, '.tutor-card-wrapper');

	jQuery(document).on('click', '.expand:not(.rem)', function(event){
		event.preventDefault();
		jQuery(this).parent().parent().prev().find(".preview-wrapper").toggleClass('on');
	});


	
	jQuery(".home_faq_section .heading").on("click", function(){
		let hadClass = jQuery(this).hasClass("in");
		jQuery(".home_faq_section .heading").removeClass("in");
		jQuery(".home_faq_section .faq").removeClass("in");
		jQuery(".home_faq_section .heading").next().hide("slow");
		if(!hadClass){
			jQuery(this).next().slideToggle();
			jQuery(this).toggleClass("in"); 
			jQuery(this).parent().toggleClass("in"); 
		}
	});
	
	jQuery('.scroll-down').on('click', function(e){
		e.preventDefault();
		let section = jQuery(this).attr('href');
		if (section.length) {
            $('html, body').animate({
                scrollTop: section.offset().top
            }, 1000); // Duration in milliseconds (1000ms = 1 second)
        }
	});


		
	jQuery.fn.autoComplete.defaults = { 
		source: 0,
		minChars: 3,
		delay: 150, 
		cache: 1,
		menuClass: '',
		renderItem: function (item, search){
			// escape special characters
			search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
			var re = new RegExp("(" + search.split(' ').join('|') + ")", "gi");
			return '<div class="autocomplete-suggestion" data-val="' + item.title + '">' + item.title.toString().replace(re, "<b>$1</b>") + '</div>';
		},
		onSelect: function(e, term, item){}
	};
	var getUrl = window.location;
	var baseUrl = getUrl .protocol + "//" + getUrl.host + "/" ;
	var currentRequest = null;
	jQuery('.search-field').autoComplete({
		minChars: 3,
		source: function(term, suggest){
			currentRequest = jQuery.ajax({
				dataType: 'json',
				url: baseUrl+ '/wp-json/v1/products/search?s='+term,
				type: 'GET',
				beforeSend: function ( xhr ) {
					if(currentRequest != null) {
						currentRequest.abort();
					}
				},
				error: function (xhr, status, error) {
				},
				success: function(data) {
					suggest(data);
				}
			});
		},
	});

	// MENU FIXED 
    if (jQuery('.header').length) { 
        var scrollTrigger = 50, // px 
            nagFix = function () {
                var scrollTop = jQuery(window).scrollTop();
                if (scrollTop > scrollTrigger) {
                    jQuery('.header').addClass('header--small', 1000, "easeOutBounce");
                    jQuery('.scrollToTop').addClass('on', 1000, "easeOutBounce");
				//	jQuery('.mobile-overlay').removeClass('small-h');
                } else {
                    jQuery('.header').removeClass('header--small', 1000, "easeOutBounce");
                    jQuery('.scrollToTop').removeClass('on', 1000, "easeOutBounce");
			//		jQuery('.mobile-overlay').removeClass('small-h');
                }
            };
        nagFix();
        jQuery(window).on('scroll', function () {
            nagFix();
        });
    };
	jQuery(window).on('scroll', function () {
                var scrollTop = jQuery(window).scrollTop();
                if (scrollTop > 50) {
					jQuery(".scrollToTop").addClass('button-show');
				}
				else{
					jQuery(".scrollToTop").removeClass('button-show');
				}
	});
});


if(document.getElementById('filter-sidebar')){
document.addEventListener('click', function(event) {
    // Select the filter sidebar and wrapper elements
    const fixed = document.querySelector('.filter-sidebar');
    const side = document.querySelector('.side-hamburger');

    // Check if the clicked target is NOT inside the sidebar or wrapper
    if (!fixed.contains(event.target) && !side.contains(event.target) && fixed.classList.contains('small-h')) {
        // If click is outside, remove the 'small-h' class from the wrapper
        fixed.classList.remove('small-h');
        side.classList.remove('open-h');
    } 
});
}